import { CONFIG } from '../../core/config';
import { RiskMatrixCell } from '../admin/risk-matrices/risk-matrix-cell';
import { CommercialImpacts } from '../commercial-impacts/commercial-impacts';
import { ViewModel } from '../view-model';

export class EquipmentFailureEffect implements ViewModel {
  friendlyTypeNameSingular: string = 'Failure Effect';
  apiRoute: string = CONFIG.apiRoutes.equipmentFailureEffect;

  selected: boolean;
  id: string;
  levels: FailureEffectLevels[] = [];
  consequences: FailureEffectConsequences[] = [];
  consequenceRiskMatrixId: string;
  selectedConsequenceRiskMatrixCellId: string;
  selectedConsequenceRiskMatrixCell: RiskMatrixCell;
  description: string;
  comments: string;
  commercialImpactId: string;
  commercialImpacts: CommercialImpacts = new CommercialImpacts();
  equipmentFailureModeId: string;
  isSaved: boolean = false;

  json() {
    return this;
  }

  loadFromJson(data: any) {
    this.id = data.id;
    this.description = data.description;
    this.comments = data.comments;
    this.isSaved = data.isSaved;
    this.consequenceRiskMatrixId = data.consequenceRiskMatrixId;
    this.selectedConsequenceRiskMatrixCellId = data.selectedConsequenceRiskMatrixCellId;

    if (data.levels) {
      this.levels = data.levels;
    }

    if (data.consequences) {
      this.consequences = data.consequences;
    }

    this.commercialImpactId = data.commercialImpactId;

    if (data.commercialImpacts) {
      this.commercialImpacts = new CommercialImpacts();
      this.commercialImpacts.loadFromJson(data.commercialImpacts);
    }

    if (data.selectedConsequenceRiskMatrixCell) {
      this.selectedConsequenceRiskMatrixCell = data.selectedConsequenceRiskMatrixCell;
    }

    this.equipmentFailureModeId = data.equipmentFailureModeId;
  }
}

export enum FailureEffectLevels {
  Next = 1,
  End = 2,
  PointOfOccurrence = 4,
}

export enum FailureEffectConsequences {
  Environmental = 0,
  Production = 1,
  PhysicalDamage = 2,
  RestorationRepair = 3,
  Safety = 4,
  RiskMatrix = 5,
}
